import React from 'react';
import { useField } from 'formik';

const AppInputField = ({ fieldType, label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <>
    {fieldType === "textarea" ? (
      <textarea
        {...field}
        {...props}
        className={`${props.className || "form-control"} ${meta.error ? "is-invalid" : ""}`}
      ></textarea>
    ):(
      <input
        {...field}
        {...props}
        className={`${props.className || "form-control"} ${meta.error ? "is-invalid" : ""}`}
      />
    )}
      {meta.touched && meta.error ? (
        <p className="invalid-feedback">{meta.error}</p>
      ) : null}
    </>
  );
};

export default AppInputField;